export default __webpack_public_path__ + "static/media/3-COACH.191dda57.pdf";